export type PaginationButton = number | 'ellipsis'

export type PaginationState = {
    totalPages: number
    rangeStart: number
    rangeEnd: number
}

export function buildPaginationPageList(
    totalPages: number,
    currentPage: number,
    maxPageButtonsToShow: number,
): PaginationButton[] {
    if (totalPages <= 0 || maxPageButtonsToShow < 3) {
        return []
    }

    const pages: PaginationButton[] = []
    const safeCurrent = Math.min(Math.max(currentPage, 1), totalPages)
    const maxButtons = Math.max(3, Math.floor(maxPageButtonsToShow))

    if (totalPages <= maxButtons) {
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i)
        }
        return pages
    }

    const middleSlots = Math.max(1, maxButtons - 2)
    const leftSlots = Math.floor(middleSlots / 2)
    const rightSlots = middleSlots - leftSlots

    pages.push(1)

    let start = safeCurrent - leftSlots
    let end = safeCurrent + rightSlots - 1

    if (start < 2) {
        const shift = 2 - start
        start = 2
        end = Math.min(totalPages - 1, end + shift)
    }

    if (end > totalPages - 1) {
        const shift = end - (totalPages - 1)
        end = totalPages - 1
        start = Math.max(2, start - shift)
    }

    if (start > 2) {
        pages.push('ellipsis')
    }

    for (let i = start; i <= end; i++) {
        pages.push(i)
    }

    if (end < totalPages - 1) {
        pages.push('ellipsis')
    }

    pages.push(totalPages)

    return pages
}

export function calculatePaginationState(
    totalItems: number,
    currentPage: number,
    pageSize: number,
): PaginationState {
    if (totalItems <= 0 || pageSize <= 0) {
        return { totalPages: 0, rangeStart: 0, rangeEnd: 0 }
    }

    const totalPages = Math.ceil(totalItems / pageSize)
    const safePage = Math.min(Math.max(currentPage, 1), totalPages)
    const rangeStart = (safePage - 1) * pageSize + 1
    const rangeEnd = Math.min(rangeStart + pageSize - 1, totalItems)

    return { totalPages, rangeStart, rangeEnd }
}
